/** Whether removing a record's association with a tag should also delete tags left unused. */
export var FlowRecordTagCleanupMode;
(function (FlowRecordTagCleanupMode) {
    FlowRecordTagCleanupMode["PreserveTags"] = "PreserveTags";
    FlowRecordTagCleanupMode["RemoveTags"] = "RemoveTags";
})(FlowRecordTagCleanupMode || (FlowRecordTagCleanupMode = {}));
/** The shape a record's aggregated tags take on the way out. */
export var FlowAggregatedTagMode;
(function (FlowAggregatedTagMode) {
    FlowAggregatedTagMode["NameList"] = "nameList";
    FlowAggregatedTagMode["TagObjectList"] = "tagObjectList";
})(FlowAggregatedTagMode || (FlowAggregatedTagMode = {}));
//# sourceMappingURL=recordTag.js.map